import {t} from 'i18next';
import {DirectionType} from '../model/enum/DirectionType';

export const directionText = (direction) => {
    switch (direction) {
        case DirectionType.FROM_WORK:
            return t('DirectionType.FROM_WORK');
        case DirectionType.TO_WORK:
            return t('DirectionType.TO_WORK');
        default:
            return t('DirectionType.UNSET');
    }
};

export const directions = [
    {name: t('DirectionType.FROM_WORK'), type: DirectionType.FROM_WORK},
    {name: t('DirectionType.TO_WORK'), type: DirectionType.TO_WORK},
    {name: t('DirectionType.UNSET'), type: DirectionType.UNSET},
];
